<template>
  <div>
    <!-- 删除软件包 -->
    <delete-box :title="'删除告警配置'" ref="delete" @removelist="deleteAlarmConfig($event,index)"></delete-box>
    <el-button type="primary" size="mini" class="addbut" @click="centerDialogVisible=true" v-if="Permission.indexOf(38)!=-1">添加</el-button>
    <!--xlsx表格导出-->
    <xlsx></xlsx>
    <!-- <p class="tabletitle"></p> -->
    <el-table
      :data="list"
      height="650"
      size="mini"
      border
      id="out-table"
      @sort-change="sortChange"
      :header-cell-style="{background:'#e4f1ff'}"
      row-key="wtId"
    >
      <el-table-column type="selection" width="35" reserve-selection :selectable="checkboxInit"></el-table-column>
      <el-table-column label="告警ID" sortable="custom">
        <template slot-scope="scope">
          <el-input v-if="scope.$index==0" size="mini" placeholder="输入告警ID" v-model="seek.wtAid"></el-input>
          <span v-if="scope.$index!==0&&scope.row.edac!=true">{{scope.row.wtAid}}</span>
          <el-input v-if="scope.row.edac==true" size="mini" v-model="scope.row.wtAid"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="告警名称" sortable="custom">
        <template slot-scope="scope">
          <el-input v-if="scope.$index==0" size="mini" placeholder="输入告警名称" v-model="seek.wtName"></el-input>
          <span v-if="scope.$index!==0&&scope.row.edac!=true">{{scope.row.wtName}}</span>
          <el-input v-if="scope.row.edac==true" size="mini" v-model="scope.row.wtName"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="告警级别" sortable="custom">
        <template slot-scope="scope">
          <el-input v-if="scope.$index==0" size="mini" placeholder="输入告警级别" v-model="seek.wtLevel"></el-input>
          <el-input v-if="scope.row.edac==true" size="mini" v-model="scope.row.wtLevel"></el-input>
          <el-tag type="danger" v-if="scope.$index!==0&&scope.row.edac!=true">{{scope.row.wtLevel}}</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column
      label="描述">
      <template slot-scope="scope">
      <el-input v-if="scope.$index==0" size="mini"></el-input>
      <span v-if="scope.$index!==0&&scope.row.edac!=true">{{scope.row.wtDescription}}</span>
      <el-input v-if="scope.row.edac==true" size="mini" v-model="scope.row.wtDescription"></el-input>
      </template>
      </el-table-column>-->
      <el-table-column label="解决方法" sortable="custom">
        <template slot-scope="scope">
          <el-input v-if="scope.$index==0" size="mini" placeholder="输入解决方法" v-model="seek.wtWay"></el-input>
          <span v-if="scope.$index!==0&&scope.row.edac!=true">{{scope.row.wtWay}}</span>
          <el-input v-if="scope.row.edac==true" size="mini" v-model="scope.row.wtWay"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="分析经验" sortable="custom">
        <template slot-scope="scope">
          <el-input v-if="scope.$index==0" size="mini" placeholder="输入告警分析经验" v-model="seek.wtExp"></el-input>
          <span v-if="scope.$index!==0&&scope.row.edac!=true">{{scope.row.wtExp}}</span>
          <el-input v-if="scope.row.edac==true" size="mini" v-model="scope.row.wtExp"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="时间" sortable="custom">
        <template slot-scope="scope">
          <el-input v-if="scope.$index==0" size="mini" placeholder="输入时间" v-model="seek.wtCreate"></el-input>
          <span v-if="scope.$index!==0&&scope.row.edac!=true">{{scope.row.wtCreate}}</span>
          <el-input v-if="scope.row.edac==true" size="mini" v-model="scope.row.wtCreate"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-edit"
            circle
            v-if="Permission.indexOf(149)!=-1&&scope.$index!==0&&scope.row.edac!=true"
            @click="scope.row.edac=true"
          ></el-button>
          <el-button
            type="success"
            icon="el-icon-check"
            circle
            v-if="scope.$index!==0&&scope.row.edac!=false"
            @click="modifyAlarmConfig(scope.$index)"
          ></el-button>
          <el-button
            v-if="Permission.indexOf(37)!=-1&&scope.$index!==0"
            type="danger"
            icon="el-icon-delete"
            circle
            @click="$refs.delete.opendelete(scope.$index)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
    ></pagination>
    <!--弹出层-->
    <el-dialog title="新增" :visible.sync="centerDialogVisible" width="40%" center>
      <div class="addconlist">
        <span>&nbsp;&nbsp;&nbsp;告警ID：</span>
        <el-input
          v-model="AlarmConfig.wtAid"
          placeholder="输入90000-99999"
          class="addinput"
          size="mini"
        ></el-input>
      </div>
      <div class="addconlist">
        <span>告警名称：</span>
        <el-input v-model="AlarmConfig.wtName" placeholder="请输入内容" class="addinput" size="mini"></el-input>
      </div>
      <div class="addconlist">
        <span>告警级别：</span>
        <el-select v-model="AlarmConfig.wtLevel" placeholder="请选择" size="mini" class="addinput">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="addconlist">
        <span style="line-height: 1.5rem">解决方法：</span>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="AlarmConfig.wtWay"
          size="mini"
          class="addinput"
        ></el-input>
      </div>
      <div class="addconlist">
        <span style="line-height: 1.5rem">经验分析：</span>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="AlarmConfig.wtExp"
          size="mini"
          class="addinput"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAlarmConfig">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  showAlarmConfig,
  addAlarmConfig,
  deleteAlarmConfig,
  modifyAlarmConfig,
  queryKeyword
} from "@/api/warnconfiguration";
//分页组件
import pagination from "@/components/pagination";
//表格转换xlsx文件
import xlsx from "@/components/xlsx";
import DeleteBox from "@/components/DeleteBox";
import { getPermission } from "../../cookie/cookie";
import { PublicComponent } from "../../mixins/common";
export default {
  mixins: [PublicComponent],
  data() {
    return {
      Permission: [],
      list: [],
      //告警级别
      options: [
        {
          value: "1",
          label: "紧急"
        },
        {
          value: "2",
          label: "主要"
        },
        {
          value: "3",
          label: "次要"
        },
        {
          value: "4",
          label: "警告"
        },
        {
          value: "5",
          label: "不确定"
        }
      ],
      //添加告警值
      AlarmConfig: {
        wtAid: "",
        wtName: "",
        wtLevel: "",
        wtWay: "",
        wtExp: ""
      },
      //修改告警绑定值
      inputs: "",
      centerDialogVisible: false,
      //搜索
      seek: {
        wtAid: "",
        wtName: "",
        wtLevel: "",
        wtWay: "",
        wtExp: "",
        wtCreate: ""
      },
      //排序
      sort: {
        wtAid: null,
        wtName: null,
        wtLevel: null,
        wtWay: null,
        wtExp: null,
        wtCreate: null
      }
    };
  },
  mounted() {
    this.showAlarmConfig();
    this.Permission = getPermission();
  },
  components: {
    pagination,
    xlsx,
    DeleteBox
  },
  methods: {
    //获取告警配置列表
    showAlarmConfig() {
      showAlarmConfig().then(res => {
        this.list = res.data.data.list;
        this.list.unshift({
          wtId: "",
          wtName: "", //名称
          wtAid: "", //告警id
          wtRole: "", //是否是系统级别（是否是系统告警 0:否 1:是）
          wtDescription: "",
          wtLevel: "", //告警级别（级别(1-5)紧急、主要、次要、警告、不确定）
          wtWay: "", //解决方法
          wtExp: "", //分析经验
          wtCreate: ""
        });
        for (let item of this.list) {
          this.$set(item, "edac", false);
          switch (item.wtLevel) {
            case 1:
              this.$set(item, "wtLevel", "紧急");
              break;
            case 2:
              this.$set(item, "wtLevel", "主要");
              break;
            case 3:
              this.$set(item, "wtLevel", "次要");
              break;
            case 4:
              this.$set(item, "wtLevel", "警告");
              break;
            case 5:
              this.$set(item, "wtLevel", "不确定");
              break;
            default:
              break;
          }
        }
      });
    },
    //添加告警
    addAlarmConfig() {
      addAlarmConfig(this.AlarmConfig).then(res => {
        if (res.data.code === 0) {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success"
          });
          this.showAlarmConfig();
        } else {
          this.$message({
            showClose: true,
            message: "添加失败，请检查输入",
            type: "warning"
          });
          this.showAlarmConfig();
        }
      });
      this.centerDialogVisible = !this.centerDialogVisible;
    },
    //删除告警
    deleteAlarmConfig(index) {
      deleteAlarmConfig(this.list[index]).then(res => {
        if (res.data.code === 0) {
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success"
          });
          this.showAlarmConfig();
        } else {
          this.$message({
            showClose: true,
            message: "删除失败",
            type: "warning"
          });
          this.showAlarmConfig();
        }
      });
    },
    //修改告警
    modifyAlarmConfig(index) {
      modifyAlarmConfig(this.list[index]).then(res => {
        if (res.data.code === 0) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
        } else {
          this.$message({
            showClose: true,
            message: "修改失败",
            type: "warning"
          });
        }
      });
      this.list[index].edac = false;
      this.showAlarmConfig();
    },
    //查询排序
    queryKeyword() {
      queryKeyword(
        [
          this.seek.wtAid,
          this.seek.wtName,
          this.seek.wtLevel,
          this.seek.wtWay,
          this.seek.wtExp,
          this.seek.wtCreate
        ],
        this.offset,
        this.limit,
        this.sort
      ).then(res => {
        this.list = res.data.data.list;
        this.total = res.data.data.total;
        this.list.unshift({});
        for (let item of this.list) {
          this.$set(item, "edac", false);
          switch (item.wtLevel) {
            case 1:
              this.$set(item, "wtLevel", "紧急");
              break;
            case 2:
              this.$set(item, "wtLevel", "主要");
              break;
            case 3:
              this.$set(item, "wtLevel", "次要");
              break;
            case 4:
              this.$set(item, "wtLevel", "警告");
              break;
            case 5:
              this.$set(item, "wtLevel", "不确定");
              break;
            default:
              break;
          }
        }
      });
    },
    //表格排序
    sortChange({ column, prop, order }) {
      //每次点击清空一次排序的赋值
      this.sort = {
        wtAid: null,
        wtName: null,
        wtLevel: null,
        wtWay: null,
        wtExp: null,
        wtCreate: null
      };
      // 未找到索引等信息，采用id值判断 //获取当前#id值，截取最后一个字符串转换成数字，再减1获取到当前索引
      let label = null;
      if (column != null) {
        label = column.label;
      } else {
        label = null;
      }
      let sortlist = null;
      if (column != null) {
        if (column.order == "ascending") {
          sortlist = 0;
        } else if (column.order == "descending") {
          sortlist = 1;
        } else {
          sortlist = null;
        }
      }
      if (label == "告警ID") {
        this.sort.wtAid = sortlist;
      } else if (label == "告警名称") {
        this.sort.wtName = sortlist;
      } else if (label == "告警级别") {
        this.sort.wtLevel = sortlist;
      } else if (label == "解决方法") {
        this.sort.wtWay = sortlist;
      } else if (label == "分析经验") {
        this.sort.wtExp = sortlist;
      } else if (label == "时间") {
        this.sort.wtCreate = sortlist;
      }
    }
  }
};
</script>

<style scoped>
.concen {
  text-align: center;
  margin: 0.5rem auto;
}

.addbut {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}

.seekright {
  float: right;
}

.rightinput {
  width: 3rem;
  margin: 0.2rem;
}

.addinput {
  display: inline-block;
  width: 4rem;
  margin: 0.2rem;
}

.addselect {
  margin: 0.2rem;
}

.addconlist {
  text-align: center;
}

.tabletitle {
  width: 100%;
  height: 0.8rem;
  font-size: 0.25rem;
  line-height: 0.8rem;
  background-color: #4284da;
  color: #ffffff;
  text-indent: 0.5rem;
}
</style>
